import { useState } from "react";
import { useSelector } from "react-redux";

import LabelNormWithUnder from "components/UI/LabelNormWithUnder";
import HeaderVisibleButton from "components/HeaderVisibleButton";

import { getVorHeaderData } from "slices/vor/vorSelectors";

const VorHeader = ({ refBlocks }) => {
	const data = useSelector(getVorHeaderData);
	const [headerFullVisible, setHeaderFullVisible] = useState(true);

	return (
		<>
			<div className="OuterHeadHidable" ref={refBlocks.headBlock1}>
				<div>
					<LabelNormWithUnder norm="Наименование программного продукта" under={data.soft_name_print} />
					<LabelNormWithUnder norm="Наименование стройки" under={data.construction_site} />
					<LabelNormWithUnder norm="Наименование объекта капитального строительства" under={data.object_name} />
				</div>
			</div>
			<div className="TableOuterHeadMainTitle">
				<div className="HeadFlex">
					<div className="TitleCenter">
						<span>Ведомость объемов работ № {data.num}</span>
						<HeaderVisibleButton
							fullVisible={headerFullVisible}
							setHeaderFullVisible={setHeaderFullVisible}
							maxHeight={"135px"}
							headersRef={[refBlocks.headBlock1.current, refBlocks.headBlock2.current]}
						/>
					</div>
				</div>
			</div>
			<div className="OuterHeadHidable" ref={refBlocks.headBlock2}>
				<div>
					<LabelNormWithUnder norm="Основание" under={data.reason} />
					<LabelNormWithUnder norm="Дата составления" under={data.date_create} />
				</div>
			</div>
		</>
	);
};

export default VorHeader;
